import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { homeFor } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PublicHeader() {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/60 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-4 py-3 sm:px-8 sm:py-4">
        <Link to="/" data-testid="brand-home-link" className="flex shrink-0 items-center" aria-label="JobPedestal home">
          <img src="/logo-icon.png" alt="JobPedestal" className="h-8 w-8 sm:hidden" data-testid="brand-logo-icon" />
          <img src="/logo-full.png" alt="JobPedestal" className="hidden h-11 w-auto sm:block" data-testid="brand-logo" />
        </Link>
        <nav className="flex items-center gap-0.5 whitespace-nowrap sm:gap-3" aria-label="Public">
          <Link to="/hourly-jobs" data-testid="header-hourly-link" className="px-2 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 sm:px-3">Shift jobs</Link>
          <Link to="/pricing" data-testid="header-pricing-link" className="px-2 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 sm:px-3">Pricing</Link>
          <Link to="/status" data-testid="header-status-link" className="hidden px-2 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 sm:inline-flex sm:px-3">Status</Link>
          {user ? (
            <Button asChild className="rounded-full" data-testid="header-open-app-button"><Link to={homeFor(user)}>Open app</Link></Button>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-link" className="px-2 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 sm:px-3">Sign in</Link>
              <Button asChild size="sm" className="rounded-full sm:h-10 sm:px-4" data-testid="header-get-started-button"><Link to="/register">Get started</Link></Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
